exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3R3f2gCNLW5gpPlzfuxB .ms-Panel-scrollableContent{overflow:hidden}._3R3f2gCNLW5gpPlzfuxB .ms-Panel-contentInner{height:calc(100% - 44px);max-height:calc(100% - 44px)}._3R3f2gCNLW5gpPlzfuxB .ms-Panel-content,._15fEVazm52q14Y1aEhPesG{overflow:hidden;height:100%}._15fEVazm52q14Y1aEhPesG{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.d26zrMZ-qRkqZKTM_OvhT{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;overflow-y:auto;height:calc(100% - 40px)}", ""]);

// exports
exports.locals = {
	"panel": "_3R3f2gCNLW5gpPlzfuxB",
	"panelContainer": "_15fEVazm52q14Y1aEhPesG",
	"panelContent": "d26zrMZ-qRkqZKTM_OvhT"
};